import type { AgentId } from './schema';

export interface RoomConfig {
  readonly id: string;
  readonly label: string;
  readonly subtitle: string;
  readonly owner: AgentId;
  readonly coords: { x: number; y: number; w: number; h: number };
  readonly accent: string;
  readonly domain: string;
}

/** Station world — 1920 × 1080 logical units. HUD overlays the bottom third
 *  (y > 620) so rooms are confined to the upper 580px. */
export const ROOMS: readonly RoomConfig[] = [
  {
    id: 'command-deck',
    label: 'Command Deck',
    subtitle: 'Jarius · CEO',
    owner: 'jarius',
    coords: { x: 440, y: 60, w: 1040, h: 200 },
    accent: 'var(--color-deck-amber)',
    domain: 'PORTFOLIO',
  },
  {
    id: 'war-room',
    label: 'War Room',
    subtitle: 'Atlas · CFO',
    owner: 'atlas',
    coords: { x: 80, y: 300, w: 420, h: 300 },
    accent: 'var(--color-deck-violet)',
    domain: 'ANALYTICS',
  },
  {
    id: 'factory-findmyfrag',
    label: 'FindMyFrag Factory',
    subtitle: 'Muse · CTO',
    owner: 'muse',
    coords: { x: 540, y: 300, w: 840, h: 300 },
    accent: 'var(--color-deck-cyan)',
    domain: 'FRAGRANCE',
  },
  {
    id: 'sales-ops',
    label: 'Sales Ops',
    subtitle: 'Jack · Lead Capture',
    owner: 'jack',
    coords: { x: 1420, y: 300, w: 420, h: 300 },
    accent: 'var(--color-deck-mint)',
    domain: 'PIPELINE',
  },
] as const;

export const ROOMS_BY_ID: Record<string, RoomConfig> = Object.fromEntries(
  ROOMS.map((r) => [r.id, r]),
);

export const STATION_SIZE = { width: 1920, height: 1080 } as const;

/** Connection graph — how info flows between rooms */
export const CONNECTIONS: readonly { from: string; to: string }[] = [
  { from: 'command-deck', to: 'war-room' },
  { from: 'command-deck', to: 'factory-findmyfrag' },
  { from: 'command-deck', to: 'sales-ops' },
  { from: 'war-room', to: 'factory-findmyfrag' },
  { from: 'war-room', to: 'sales-ops' },
] as const;
